import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash'

import {Flex, SVGButton, UpgradeModal} from '/app/src/component';
import SVG from 'react-inlinesvg';
import style from './style.css'
import CustomizationModel from '/app/src/model/Customization/model'
import {CustomizationSelector, CompanySelector} from '/app/src/model/selectors'
import {history} from '/app/src/store'

class HelpdeskIntroduction extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            upgradeHover: false,
            selected: null,
            modal: false,
        }
        const mode = this.props.currentMode
        this.isStandard = mode ==='start' || mode === 'standard'
        this.isPremium = mode === 'pro'
        this.setSelected = this.setSelected.bind(this)
        this._renderFAQButton = this._renderFAQButton.bind(this)
        this._renderHelpdeskButton = this._renderHelpdeskButton.bind(this)
        this.toggleModal = this.toggleModal.bind(this);
        this._handleUpgradeClick = this._handleUpgradeClick.bind(this)
    }

    componentDidMount(){
        this.setState({selected: this.props.faqType});
    }

    setSelected(select){
        return ()=>{
            this.setState({selected: select})
        }
    }
    componentDidUpdate(prevProps){
        if(prevProps.faqType !== this.props.faqType){
            history.push('/clientChat/faq/'+this.props.faqType)
        }
    }

    _onConfirmClick(selected){
        if(selected === 'helpdesk'){
            if (_.includes(['standard', 'start'], this.props.currentMode)) {
                this.toggleModal();
                return;
            }
        }

        if(this.props.faqType !== selected){
            this.props.updateChoice(selected);
        }
        history.push('/clientChat/faq/'+selected)
    }

    toggleModal(){
        this.setState({modal: !this.state.modal})
    }

    _handleUpgradeClick() {
        if (this.isStandard) {
            this.toggleModal()
        } else {
            this.setSelected('helpdesk')()
        }
    }

    _renderFAQButton(){
        const faqSelected = this.state.selected==='faq'
        return (
            <Flex column w='300px' hAlignContent='center'>
                <Flex w='278px' h='278px' column
                borderRadius='100%' center cursor='pointer'
                onClick={this.setSelected('faq')}
                backgroundHover={faqSelected?'none':'#f7f7f7'}
                border={faqSelected &&'3px solid #2ea2d2'}
                backgroundColor={faqSelected&&'#f4fdff'}>
                    <SVG  cacheGetRequests={true} style={{'fill': '#f64b7f', 'height': '94px', 'width': '94px'}}
                    src='/images/Menu_ClientChatForms.svg'/>
                    <Flex color='black' fontSize='36px' fontWeight='300' marginTop='5px'>
                        FAQ
                    </Flex>
                </Flex>
                <Flex color='black' fontSize='16px' fontWeight='300' marginTop='10px'>
                    En enkel lista med vanliga frågor och svar, där besökaren kan söka och bläddra själv.
                </Flex>
            </Flex>
        )
    }
    _renderHelpdeskButton(){
        const helpdeskSelected = this.state.selected==='helpdesk'
        const isHover = this.state.upgradeHover

        var buttonClass = ''
        if(this.isStandard){
            buttonClass = isHover && style.Filter
        }

        return (
            <Flex column w='300px' hAlignContent='center' position='relative'>
                {this.isStandard &&
                <Flex w='278px' h='278px'
                    column borderRadius='100%'
                    center cursor='pointer'
                    position='absolute' z='1'
                    opacity={isHover?1:0}
                    onClick={this._handleUpgradeClick}
                    onMouseEnter = {()=>this.setState({upgradeHover: true})}
                    onMouseLeave = {()=>this.setState({upgradeHover: false})}
                >
                    <Flex w='94px' h='94px'/>
                    <Flex color='#8a499a' fontSize='36px' fontWeight='300' marginTop='5px'>
                        Uppgradera
                    </Flex>
                    <Flex color='purple' marginTop='6px'>
                        PRO
                    </Flex>
                </Flex>
                }

                <Flex w='278px' h='278px'
                    column borderRadius='100%' center cursor='pointer'
                    backgroundHover={helpdeskSelected?'none':'#f7f7f7'}
                    border={helpdeskSelected&&'3px solid #2ea2d2'}
                    backgroundColor={helpdeskSelected&&'#f4fdff'}
                    className={buttonClass}
                    onClick={this._handleUpgradeClick}>

                    <SVG  cacheGetRequests={true} style={{'fill': '#f64b7f', 'height': '94px', 'width': '94px'}}
                        src='/images/Menu_ClientChatForms.svg'/>

                    <Flex color='black' fontSize='36px' fontWeight='300' marginTop='5px'>
                        Helpdesk
                    </Flex>

                    <Flex color='purple' marginTop='6px' fontSize='20px'>
                        PRO
                    </Flex>
                </Flex>
                <Flex color='black' fontSize='16px' fontWeight='300' marginTop='10px'>
                    Mer utvecklad kunskapsbank med frågor och svar i form av stylade artikelsidor.
                </Flex>
            </Flex>
        )

    }
    render() {
        const { selected } = this.state;
        let SaveButton = <SVGButton src='/images/Save.svg' text='Välj'
                border marginTop='20px' h='44px' w='120px' borderRadius='30px'
                color='lightgrey'cursor='default'
                />

        if(selected){
            SaveButton =  <SVGButton src='/images/Save.svg' text='Välj'
            border marginTop='20px' h='44px' w='120px' borderRadius='30px'
            hover='blue'
            onClick={() => this._onConfirmClick(selected)}/>
        }
        return (
            <Flex hAlignContent='center' column grow w='100%'>

                <Flex fontSize='36px' color='black' fontWeight='300' marginTop='15%' marginBottom='20px'>
                    Välj funktion
                </Flex>

                <Flex w='100%' hAlignContent='center'>

                    {this._renderFAQButton()}

                    <Flex w='50px'/>

                    {this._renderHelpdeskButton()}

                </Flex>
                <Flex mt='20px'>
                    {SaveButton}
                </Flex>
                <UpgradeModal
                    contentType='helpdesk'
                    onClick={() => history.push('/companySettings/upgrade')}
                    open={this.state.modal}
                    onClose={this.toggleModal}
                    updateChoice={() => this.props.updateChoice(selected)}/>
            </Flex>

        )
    }
}

const  {dispatcher: updatesRequest} = CustomizationModel.updates()

function mapDispatchToProps(dispatch, props){
    return {
        updateChoice: (faqType)=>dispatch(updatesRequest({'faq_type':faqType}))
    }
}

function mapStateToProps(state, props){
    return {
        companyId: state.getIn(['company', 'info', 'id']),
        faqType: CustomizationSelector.getFaqType(state),
        faqActive: CustomizationSelector.getFaqActive(state),
        currentMode: CompanySelector.getPaymentPlan(state)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpdeskIntroduction);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Introduction/index.js